import { useEffect } from 'react';

import { ChakraBox } from '@equip.health/ui';

import Header from '~/components/common/Header';
import { PAGE_LAYOUT, PAGE_TOP_PADDING } from '~/lib/constants';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';

import SettingsTabs from './Tabs';

const Settings = () => {
  const { setIsOnSettings } = useGlobalContext();

  useEffect(() => {
    setIsOnSettings(true);
    return () => setIsOnSettings(false);
  }, [setIsOnSettings]);

  return (
    <ChakraBox
      paddingRight={PAGE_LAYOUT.rightSpacing}
      paddingTop={PAGE_TOP_PADDING}
    >
      <Header title="Settings" />
      <SettingsTabs />
    </ChakraBox>
  );
};

export default Settings;
